import { Role, User } from '../../gs-core/common';
import '../../gs-core/common/util/array.prototype';

// TODO - put the userType's into gs-core
const roleToUserTypeMap = {
  STUDENT: 'Person',
  POSTDOC: 'Person',
  SUBUNIT: 'MajorProgram'
};

export const EDocsRoles = {
  PROGRAM_COORDINATOR: { code: 'PROGRAM_COORDINATOR', name: 'Program Coordinator' } as Role,
  CHAIR: { code: 'CHAIR', name: 'Chair' } as Role,
  EMPLOYEE: { code: 'EMPLOYEE', name: 'Employee' } as Role,
  STUDENT: { code: 'STUDENT', name: 'Student' } as Role,
  MAJOR_PROFESSOR_MENTOR: { code: 'MAJOR_PROFESSOR_MENTOR', name: 'Major Professor' } as Role,
  STUDENT_ASSISTANT: { code: 'STUDENT_ASSISTANT', name: 'Student Assistant' } as Role,
  MEMBER: { code: 'MEMBER', name: 'Member' } as Role,
  DIRECTOR: { code: 'DIRECTOR', name: 'Director' } as Role,
  POSTDOC: { code: 'POSTDOC', name: 'Postdoctoral Scholar' } as Role,
  SUBUNIT: { code: 'SUBUNIT', name: 'Subunit' } as Role,
  API_CONSUMER: { code: 'API_CONSUMER', name: 'API Consumer' } as Role,

  get ALL(): Role[] {
    return Object.keys(EDocsRoles)
      .filter(name =>
        name !== 'ALL' && typeof EDocsRoles[name] === 'object'
      )
      .map(name => EDocsRoles[name] as Role);
  },

  fromGroup(group: User): Role[] {
    if (!group.isOfType) {
      throw new Error(`Group ${group.id} is not a UserModel`);
    }
    if (group.isOfType('Institution')) {
      return [EDocsRoles.STUDENT, EDocsRoles.POSTDOC, EDocsRoles.SUBUNIT];
    } else if (group.isOfType('CollegeUnit') || group.isOfType('MajorProgram')) {
      return [EDocsRoles.STUDENT, EDocsRoles.SUBUNIT];
    } else if (group.isOfType('Department')) {
      return [EDocsRoles.POSTDOC];
    }

    throw new Error(`Group class of ${group.clazz} was invalid`);
  },

  toUserType(roleOrCode: Role | string): string {
    const roleCode = roleOrCode && (roleOrCode as Role).code ? (roleOrCode as Role).code : roleOrCode as string;
    const userType = roleToUserTypeMap[roleCode];

    if (!userType) {
      throw new Error(`Invalid role ${roleCode}`);
    }

    return userType;
  }
};



// WEBPACK FOOTER //
// ./src/common/models/EDocsRoles.ts